import { render, staticRenderFns } from "./reportMerchant.vue?vue&type=template&id=1928b818&scoped=true"
import script from "./reportMerchant.vue?vue&type=script&lang=js"
export * from "./reportMerchant.vue?vue&type=script&lang=js"
import style0 from "./reportMerchant.vue?vue&type=style&index=0&id=1928b818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928b818",
  null
  
)

export default component.exports